import { render, staticRenderFns } from "./SpeechToText.vue?vue&type=template&id=ed63cf14&"
import script from "./SpeechToText.vue?vue&type=script&lang=js&"
export * from "./SpeechToText.vue?vue&type=script&lang=js&"
import style0 from "./SpeechToText.vue?vue&type=style&index=0&id=ed63cf14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports